import React, { useState } from "react";
import ItemInForm from "./itemInForm.js";
export default function BottomPart() {
  
  return (
    <ItemInForm content={'Phone number'}/>
  );
}
